<script setup lang="ts">
</script>

<template>
  <div class="c-memberPanel">
    <div class="c-memberPanel_body">
      <div class="c-memberPanel_body_box">
        <p class="c-memberPanel_body_box_text">
          IMメンバーになるとお客様のための<br>おすすめの展覧会の情報をお届けします。
        </p>

        <nuxt-link
          v-bind:to="{ name: 'signup' }"
          class="c-memberPanel_body_box_link"
        >
          <div
            class="c-memberPanel_body_box_link_btn"
          >
            <v-icon class="c-memberPanel_body_box_link_btn_icon">
              mdi-chevron-right
            </v-icon>
            <div class="c-memberPanel_body_box_link_btn_text">
              <span class="c-memberPanel_body_box_link_btn_text_upper">
                会員登録はこちら
              </span>
              <span class="c-memberPanel_body_box_link_btn_text_lower">
                （登録無料）
              </span>
            </div>
          </div>
        </nuxt-link>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@use "@/assets/css/foundation/mixin/responsive" as responsive;

.c-memberPanel {
  display: flex;
  justify-content: center;
  width: 100%;
  background-color: #159197;

  &_body {
    display: flex;
    align-items: center;
    justify-content: center;
    width: calc(1140px + (62px * 2));
    background-image: url("../assets/images/im-logo-bkg-pc.png");
    background-position: left bottom;

    @include responsive.mq_down(sp) {
      display: block;
      width: 100%;
      background-image: url("../assets/images/im-logo-bkg-sp.png");
    }

    &_box {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: var(--g_min_screen_width_pc);
      padding: 38px var(--g_guide_margin_pc);

      @include responsive.mq_down(sp) {
        display: block;
        width: 100%;
        padding: 40px 17px;
      }

      &_text {
        margin-bottom: 0;
        color: var(--g_color_text_white);
        font-family: var(--g_font_family_NotoSansCJKjp);
        font-size: 24px;
        line-height: 1.5;

        @include responsive.mq_down(sp) {
          font-size: 18px;
        }
      }

      &_link {
        text-decoration: none;

        &:hover {
          opacity: 0.7;
        }

        @include responsive.mq_down(sp) {
          display: flex;
          justify-content: center;
          width: 100%;
        }

        &_btn {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 320px;
          padding: 15.5px 0;
          border: solid 2px #ffff;
          border-radius: 4px;

          @include responsive.mq_down(sp) {
            width: 100%;
            max-width: 342px;
            margin-top: 25px;
            padding: 11.5px 10px;
          }

          &_icon {
            color: #ffff;
            font-size: 36px;
          }

          &_text {
            display: flex;
            flex-direction: column;
            align-items: center;

            &_upper {
              color: #ffff;
              font-size: 18px;
              font-weight: bold;
              line-height: 1;
            }

            &_lower {
              margin-top: 7px;
              color: #ffff;
              font-size: 12px;
              line-height: 1;
            }
          }
        }
      }
    }
  }
}
</style>
